var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterClosepost({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 11.3L8.24307 6.91341L12.5564 2.60012C12.9322 2.22429 12.9322 1.6192 12.5564 1.24337C12.1807 0.867668 11.5754 0.867547 11.1996 1.24337L6.91281 5.55678L2.69916 1.34313C2.32333 0.967308 1.71824 0.967308 1.34241 1.34313C0.966709 1.71884 0.966708 2.32393 1.34253 2.69976L5.54953 6.90676L1.2493 11.207C0.873719 11.5826 0.873478 12.1879 1.2493 12.5637C1.62513 12.9396 2.23046 12.9393 2.60605 12.5637L6.90616 8.26362L11.2994 12.6568C11.6752 13.0327 12.2805 13.0324 12.6561 12.6568C13.0321 12.2809 13.0287 11.6724 12.6562 11.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterClosepost);
export default __webpack_public_path__ + "static/media/footer_closepost.f06801fde860910ef93253f10bc495f8.svg";
export { ForwardRef as ReactComponent };